import { render, staticRenderFns } from "./requirementSummary.vue?vue&type=template&id=a22cf9b4&scoped=true"
import script from "./requirementSummary.vue?vue&type=script&lang=js"
export * from "./requirementSummary.vue?vue&type=script&lang=js"
import style0 from "./requirementSummary.vue?vue&type=style&index=0&id=a22cf9b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22cf9b4",
  null
  
)

export default component.exports